export const ROUTER_FEATURE_TOKEN = 'router'
